import { render } from "./NavBarGuest.vue?vue&type=template&id=5839db0a&scoped=true"
import script from "./NavBarGuest.vue?vue&type=script&lang=js"
export * from "./NavBarGuest.vue?vue&type=script&lang=js"

import "./NavBarGuest.vue?vue&type=style&index=0&id=5839db0a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5839db0a"]])

export default __exports__